// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shop-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 3H3V21H21V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M9 6V3H3V6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M9 6V3H15V6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M15 6V3H21V6C21 7.65686 19.6569 9 18 9C16.3431 9 15 7.65685 15 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M15 14H9V21H15V14Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 3V6M9 3H3V6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6M9 3H15M9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6M15 3V6M15 3H21V6C21 7.65685 19.6569 9 18 9C16.3431 9 15 7.65685 15 6M9 14H15V21H9V14Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 3H3V21H21V3Z","strokeWidth":"props.strokeWidth"}}]}]};

const Shop1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shop-1',
    ref,
    icon: element,
  },
));

Shop1Icon.displayName = 'Shop1Icon';

export default Shop1Icon;
